import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LandingPage } from '@app/shared/enums/LandingPage.enum';

@Pipe({
    name: "landingPagePipe",
    standalone: false
})
export class LandingPagePipe implements PipeTransform {
  public operationType = LandingPage;
  public landingPages: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.LANDINGPAGE_' + key);
    }
  }

  getList() {
    this.landingPages = [];
    for (const [propertyKey, propertyValue] of Object.entries(LandingPage)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.LANDINGPAGE_' + propertyKey);
      this.landingPages.push({
        id: propertyKey,
        name: nameAndText,
        text: nameAndText
      });
    }

    return this.landingPages;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(LandingPage)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return {
          id: propertyValue,
          name: nameAndText,
          text: nameAndText
        };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(LandingPage)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
